module.exports = "<div id=\"content\">\n\t<ng-include src=\"'controls.html'\"></ng-include>\n\n\t<div id=\"chart\" class=\"chart\"></div>\n\n\t<ng-include ng-if=\"!reportCtrl.AppService.compare\" src=\"'base-table.html'\"></ng-include>\n\t<ng-include ng-if=\"reportCtrl.AppService.compare\" src=\"'compare-table.html'\"></ng-include>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./resources/views/html/standard-report.html
 ** module id = 31
 ** module chunks = 0
 **/